// dependency-graph-ignore-file
// Delete once we use this file^
import { type InputCapture } from '@canvas/input';

import { type SelectionMachine } from '../../machine/selection-machine';
import { type SelectionInput } from '../types';

import { createEventLoop } from './event-loop';
import { getClickTarget } from './get-click-target';
import { createIdleState } from './mouse-state-machine';

export function createMouseInput(
  machine: SelectionMachine,
  inputCapture: InputCapture
): SelectionInput {
  const idleState = createIdleState(machine, inputCapture, getClickTarget);
  const eventLoop = createEventLoop(inputCapture, idleState);

  return {
    setup() {
      eventLoop.start();
    },
    dispose() {
      eventLoop.stop();
    },
  };
}
